module.exports = __webpack_public_path__ + "img/ns_feel.c16fc26e.jpg";